import {VideoElement} from './VideoElement.interface';

declare global {
  interface Document {
    mozCancelFullScreen?: any;
    webkitExitFullscreen?: any;
    webkitFullscreenElement?: any;
    fullscreenElement?: any;
    msFullscreenElement?: any;
    mozFullscreenElement?: any;
    mozFullScreenEnabled?: any;
    webkitFullscreenEnabled?: any;
  }
}

/**
 * 현재 브라우저에 전체화면인 요소가 있는지의 여부를 반환하는 함수.
 */
export function getIsFullScreen() {
  return !!(
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullscreenElement
  );
}

export function openVideoFullScreen(video: VideoElement) {
  if (video.requestFullscreen) {
    video.requestFullscreen();
  } else if (video.webkitRequestFullScreen) {
    video.webkitRequestFullScreen();
  } else if (video.webkitEnterFullscreen) {
    video.webkitEnterFullscreen();
  } else if (video.mozRequestFullScreen) {
    video.mozRequestFullScreen();
  } else if (video.msRequestFullscreen) {
    video.msRequestFullscreen();
  }
}

/**
 * 전체화면을 종료하는 함수.
 * IOS에서는 fullscreen API를 제공하지 않기 때문에 정상적으로 동작하지 않는다.
 */

export function closeVideoFullScreen() {
  if (!getIsFullScreen()) {
    return;
  }

  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
}

export function getIsFullScreenEnabled(video?: VideoElement) {
  return !!(
    document.fullscreenEnabled ||
    document.mozFullScreenEnabled ||
    document.webkitFullscreenEnabled ||
    (video && video.webkitSupportsFullscreen)
  );
}
